import Component from "@glimmer/component"
import FilterClassesIsland from "react-app/islands/FilterClassesIsland"

interface Signature {
  Args: {
    planbookId: string
    hiddenCourseIds: string[]
    toggleCourseId: (courseId: string) => void
    showAllCourses: () => void
    hideAllCourses: () => void
    classesLinedUp: boolean
    toggleClassesLinedUp: () => void
    hideClassesLinedUpToggle: boolean
    lessonsCollapsed: boolean
    toggleCollapseLessons: () => void
  }
}

export default class FilterClassesIslandBridge extends Component<Signature> {
  readonly FilterClassesIsland = FilterClassesIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::FilterClassesIslandBridge": typeof FilterClassesIslandBridge
  }
}
